import { Component , EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  @Input() pageIndex = 0;
  @Input() pageSize = 10;
  @Input() pageLength = 0;
  @Output() pageChange = new EventEmitter<PageEvent>();

  pageSizeOptions: number[] = [10, 20, 30, 40, 50, 100, 150, 200, 500, 1000,10000];

  onClickPaging(event?: any) {
    this.pageChange.emit({
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      length: this.pageLength
    } as PageEvent);
  }

  getTotalPages(): number {
    return Math.ceil(this.pageLength / this.pageSize);
  }

  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const currentPage = this.pageIndex + 1;
    const pages: number[] = [];

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - 2 && i <= currentPage + 2)
      ) {
        pages.push(i);
      }
    }

    return pages;
  }

  goToPage(page: number) {
    this.pageIndex = page - 1;
    this.onClickPaging();
  }

  firstPage() {
    this.pageIndex = 0;
    this.onClickPaging();
  }

  prevPage() {
    if (this.pageIndex > 0) {
      this.pageIndex--;
      this.onClickPaging();
    }
  }

  nextPage() {
    if (this.pageIndex < this.getTotalPages() - 1) {
      this.pageIndex++;
      this.onClickPaging();
    }
  }

  lastPage() {
    this.pageIndex = this.getTotalPages() - 1;
    this.onClickPaging();
  }

  onPageSizeChange(event: any) {
    this.pageSize = event.target.value;
    this.pageIndex = 0;
    this.onClickPaging();
  }

  getStartIndex(): number {
    return this.pageIndex * this.pageSize + 1;
  }

  getEndIndex(): number {
    return Math.min((this.pageIndex + 1) * this.pageSize, this.pageLength);
  }
}
